/**
 * @module components/YAxisSetting/dualYAxisConstants
 * @description 折线双 Y 轴空轴默认值
 */

import type { ILineDualAxisConfig } from '../common/DualAxis/types';

export const createEmptyLineAxis = (
  chartType: string,
): ILineDualAxisConfig => ({
  yAxisName: '',
  metrics: [],
  chartType,
  yAxisRangeSwitch: false,
});
